import { useApi } from "@platform/api";
import { useQuery } from "@tanstack/react-query";

import { listCarriers } from "../api/client";

import type { CarrierRepDirectoryCarrierResponse } from "../api/types";
import type { Carrier } from "../types";

const CARRIERS_QUERY_KEY = ["carriersRepDirectory", "carriers"];
const UNNAMED_CARRIER_NAME = "Unnamed carrier";
const LOAD_CARRIERS_ERROR_MESSAGE = "Unable to load carriers.";

interface UseCarriersQueryResult {
  carriers: Carrier[];
  loading: boolean;
  error: string | null;
}

const mapCarrier = (carrier: CarrierRepDirectoryCarrierResponse): Carrier => ({
  id: carrier.id,
  name: carrier.name || UNNAMED_CARRIER_NAME,
  isContracted: carrier.isContracted ?? false,
  repsCount: carrier.carrierRepsCount,
});

export const useCarriersQuery = (): UseCarriersQueryResult => {
  const axiosInstance = useApi();

  const query = useQuery<
    CarrierRepDirectoryCarrierResponse[],
    Error,
    Carrier[]
  >({
    queryKey: CARRIERS_QUERY_KEY,
    queryFn: () => listCarriers(axiosInstance),
    select: (response) => response.map(mapCarrier),
  });

  return {
    carriers: query.data ?? [],
    loading: query.isFetching,
    error: query.error ? LOAD_CARRIERS_ERROR_MESSAGE : null,
  };
};
